"use strict";

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/objectSpread2.js"));

var _vuex = require("vuex");

//
//
//
//
//
var _default = {
  name: 'GoVip',
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['vipLevel', 'isVip'])),
  created: function created() {
    console.log(this.isVip);

    if (this.isVip) {
      this.$router.push('/');
    }
  }
};
exports.default = _default;